import {
  STORE_SUPPORT_HEALTH_ERROR,
  STORE_SUPPORT_HEALTH_REQUEST,
  STORE_SUPPORT_HEALTH_SUCCESS,
} from "./ActionType";

const initialState = {
  isRequest: false,
  isSuccess: false,
  isError: false,
  data: null,
  error: null,
  shopId: null,
  requestId: null,
};

const matchesActiveRequest = (state, action) =>
  state.shopId === action.meta?.shopId &&
  state.requestId === action.meta?.requestId;

const storeSupportHealthReducer = (state = initialState, action) => {
  switch (action.type) {
    case STORE_SUPPORT_HEALTH_REQUEST:
      return {
        ...state,
        isRequest: true,
        isSuccess:
          state.shopId === action.meta?.shopId ? state.isSuccess : false,
        isError: false,
        data: state.shopId === action.meta?.shopId ? state.data : null,
        error: null,
        shopId: action.meta?.shopId ?? null,
        requestId: action.meta?.requestId ?? null,
      };
    case STORE_SUPPORT_HEALTH_SUCCESS:
      if (!matchesActiveRequest(state, action)) return state;
      return {
        ...state,
        isRequest: false,
        isSuccess: true,
        isError: false,
        data: action.payload,
        error: null,
      };
    case STORE_SUPPORT_HEALTH_ERROR:
      if (!matchesActiveRequest(state, action)) return state;
      return {
        ...state,
        isRequest: false,
        isSuccess: false,
        isError: true,
        error: action.payload,
      };
    default:
      return state;
  }
};

export default storeSupportHealthReducer;
